import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { VideoSettings } from './VideoSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { EditableVideo } from '@components/atoms'
import {
  videoDefaultProps,
  videoItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'
import { layoutDefaultProps } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const defaultProps = {
  ...videoDefaultProps(),
  ...layoutDefaultProps('none'),
}

export const dynamicProps = []

export const Video: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-video ${
          !blockProps.videoId && !blockProps.url ? 'block-video--empty' : ''
        } block-video--st-${blockProps.spaceTop} block-video--sb-${blockProps.spaceBottom} ${
          props.className
        }`}
      >
        <EditableVideo item={videoItemParams(blockProps)?.video} editMode={enabled} preserveRatio />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

Video.craft = withCraft({
  name: 'Video',
  defaultProps: defaultProps,
  settings: VideoSettings,
})
